import { INavData } from '@coreui/angular-pro';
import { marker } from '@jsverse/transloco-keys-manager/marker';

export interface AppNavData extends INavData {
  requiredRolesAny?: string[];
  requiredRolesAll?: string[];
  children?: AppNavData[];
}

export const navItems: AppNavData[] = [
  {
    name: marker('nav.home'),
    url: '/home',
    iconComponent: { name: 'cil-home' },
  },

  {
    url: '/tenant-management',
    name: marker('nav.tenantManagement.title'),
    iconComponent: { name: 'cilGrid' },
    requiredRolesAny: ['superadmin'],
    children: [
      {
        name: marker('nav.tenantManagement.tenants'),
        url: '/tenant-management/tenants',
        icon: 'nav-icon-bullet',
        linkProps: { routerLinkActiveOptions: { exact: true } },
        requiredRolesAny: ['superadmin'],
      },
      {
        name: marker('nav.tenantManagement.createTenant'),
        url: '/tenant-management/tenants/create',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['superadmin'],
      },
      {
        name: marker('nav.tenantManagement.myTenant'),
        url: '/tenant-management/my-tenant',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['superadmin'],
      },
    ],
  },

  {
    url: '/user-management',
    name: marker('nav.userManagement.title'),
    iconComponent: { name: 'cilPeople' },
    requiredRolesAny: [
      'users.read',
      'users.create',
      'users.role',
      'users.group',
    ],
    children: [
      {
        name: marker('nav.userManagement.users'),
        url: '/user-management/users',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['users.read', 'users.create'],
      },
      {
        name: marker('nav.userManagement.roles'),
        url: '/user-management/roles',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['users.role'],
      },
      {
        name: marker('nav.userManagement.groups'),
        url: '/user-management/groups',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['users.group'],
      },
    ],
  },
  {
    name: marker('nav.shops'),
    url: '/shops',
    iconComponent: { name: 'cilGrid' },
    requiredRolesAny: ['admin', 'superadmin', 'shops.management'],
  },
  {
    url: '/wallet',
    name: marker('nav.wallet.title'),
    iconComponent: { name: 'cil-wallet' },
    requiredRolesAny: [
      'admin',
      'superadmin',
      'wallet.types',
      'wallet.bonus',
      'wallet.transactions',
      'wallet.management',
      'wallet.managment',
    ],
    children: [
      {
        name: marker('nav.wallet.currencies'),
        url: '/wallet/currencies',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['admin', 'superadmin', 'wallet.types', 'wallet.management', 'wallet.managment'],
      },
      {
        name: marker('nav.wallet.walletDefault'),
        url: '/wallet/wallet-default',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['admin', 'superadmin', 'wallet.types', 'wallet.management', 'wallet.managment'],
      },
      {
        name: marker('nav.wallet.bonusDefinition'),
        url: '/wallet/bonus-definition',
        icon: 'nav-icon-bullet',
        requiredRolesAny: [
          'wallet.bonus',
          'wallet.management',
          'wallet.managment',
        ],
      },
      {
        name: marker('nav.wallet.walletTypes'),
        url: '/wallet/wallet-types',
        icon: 'nav-icon-bullet',
        requiredRolesAny: [
          'wallet.types',
          'wallet.management',
          'wallet.managment',
        ],
      },
      {
        name: marker('nav.wallet.transactions'),
        url: '/wallet/transactions',
        icon: 'nav-icon-bullet',
        requiredRolesAny: [
          'wallet.transactions',
          'wallet.management',
          'wallet.managment',
        ],
      },
      {
        name: marker('nav.wallet.withdrawalRules'),
        url: '/wallet/withdrawal-rules',
        icon: 'nav-icon-bullet',
        requiredRolesAny: [
          'wallet.types',
          'wallet.management',
          'wallet.managment',
        ],
      },
    ],
  },

  {
    url: '/analytics',
    name: marker('nav.analytics.title'),
    iconComponent: { name: 'cilChart' },
    requiredRolesAny: ['crm'],
    children: [
      {
        name: marker('nav.analytics.analytics'),
        url: '/analytics/dashboard',
        icon: 'nav-icon-bullet',
      },
      {
        name: marker('nav.analytics.shopPerformance'),
        url: '/analytics/shops',
        icon: 'nav-icon-bullet',
      },
      {
        name: marker('nav.analytics.exposureSettlement'),
        url: '/analytics/performance',
        icon: 'nav-icon-bullet',
      },
      {
        name: marker('nav.analytics.fraudAlerts'),
        url: '/analytics/fraud',
        icon: 'nav-icon-bullet',
      },
      {
        name: marker('nav.analytics.comparison'),
        url: '/analytics/comparison',
        icon: 'nav-icon-bullet',
      },
      {
        name: marker('nav.analytics.ai'),
        url: '/analytics/ai',
        icon: 'nav-icon-bullet',
      },
    ],
  },

  {
    url: '/crm',
    name: marker('nav.crm.title'),
    iconComponent: { name: 'cilDollar' },
    requiredRolesAny: ['crm'],
    children: [
      {
        name: marker('nav.crm.player360'),
        url: '/crm/players',
        icon: 'nav-icon-bullet',
      },
      {
        name: marker('nav.crm.segments'),
        url: '/crm/segments',
        icon: 'nav-icon-bullet',
      },
      {
        name: marker('nav.crm.campaigns'),
        url: '/crm/campaigns',
        icon: 'nav-icon-bullet',
      },
      {
        name: marker('nav.crm.riskConfig'),
        url: '/crm/risk-config',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['crm'],
      },
    ],
  },

  {
    url: '/tickets',
    name: marker('nav.tickets.title'),
    iconComponent: { name: 'cilNotes' },
    requiredRolesAny: ['tickets.read', 'tickets.config', 'tickets.layout'],
    children: [
      {
        name: marker('nav.tickets.openBets'),
        url: '/tickets/open',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['tickets.read'],
      },
      {
        name: marker('nav.tickets.settledBets'),
        url: '/tickets/settled',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['tickets.read'],
      },
      {
        name: marker('nav.tickets.ticketsList'),
        url: '/tickets/list',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['tickets.read'],
      },
      {
        name: marker('nav.tickets.fastCodes'),
        url: '/tickets/fast-codes',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['tickets.read','tickets.config'],
      },
      {
        name: marker('nav.tickets.ticketLimits'),
        url: '/tickets/limits',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['tickets.config'],
      },
      {
        name: marker('nav.tickets.bonusRules'),
        url: '/tickets/bonus-rules',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['tickets.config'],
      },
      {
        name: marker('nav.tickets.ticketLayout'),
        url: '/tickets/ticket-layout',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['tickets.layout'],
      },
    ],
  },

  {
    url: '/risk',
    name: marker('nav.risk.title'),
    iconComponent: { name: 'cil-bell-exclamation' },
    requiredRolesAny: ['risk'],
    children: [
      {
        name: marker('nav.risk.riskRules'),
        url: '/risk/risk-rules',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['risk'],
      },
      {
        name: marker('nav.risk.manualVerification'),
        url: '/risk/manual-verification',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['risk'],
      },
    ],
  },

  {
    url: '/sportbook',
    name: marker('nav.sportbook.title'),
    iconComponent: { name: 'cilStar' },
    requiredRolesAny: ['list.management', 'configuration'],
    children: [
      {
        url: '/sportbook/betting-list',
        name: marker('nav.sportbook.bettingList.title'),
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['list.management'],
        children: [
          {
            name: marker('nav.sportbook.bettingList.eventLists'),
            url: '/sportbook/betting-list/overview-v2',
          },
          {
            name: marker('nav.sportbook.bettingList.bettingCodes'),
            url: '/sportbook/betting-list/betting-codes',
          },
          {
            name: marker('nav.sportbook.bettingList.eventsManagement'),
            url: '/sportbook/betting-list/events-management',
          },
          {
            name: marker('nav.sportbook.bettingList.topEvents'),
            url: '/sportbook/betting-list/top-events',
          },
          {
            name: marker('nav.sportbook.bettingList.customEvents'),
            url: '/sportbook/betting-list/custom-events',
          },
          {
            name: marker('nav.sportbook.bettingList.listCodes'),
            url: '/sportbook/betting-list/list-codes',
          },
        ],
      },
      {
        url: '/sportbook/markets',
        name: marker('nav.sportbook.markets.title'),
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['configuration'],
        children: [
          {
            name: marker('nav.sportbook.markets.manage'),
            url: '/sportbook/markets/markets',
          },
          {
            name: marker('nav.sportbook.markets.marketTranslations'),
            url: '/sportbook/markets/market-translations',
          },
          {
            name: marker('nav.sportbook.markets.groupTranslations'),
            url: '/sportbook/markets/group-translations',
          },
          {
            name: marker('nav.sportbook.markets.catalog'),
            url: '/sportbook/markets/catalog',
          },
          {
            name: marker('nav.sportbook.markets.groups'),
            url: '/sportbook/markets/groups',
          },
        ],
      },
      {
        name: marker('nav.sportbook.priority.title'),
        url: '/sportbook/priority',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['configuration'],
        children: [
          {
            name: marker('nav.sportbook.priority.leagues'),
            url: '/sportbook/priority/leagues',
          },
          {
            name: marker('nav.sportbook.priority.groups'),
            url: '/sportbook/priority/groups',
          },
        ],
      },
      {
        name: marker('nav.sportbook.sidebarConfig.title'),
        url: '/sportbook/sidebar-config',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['configuration'],
        children: [
          {
            name: marker('nav.sportbook.sidebarConfig.sports'),
            url: '/sportbook/sidebar-config/sports',
            icon: 'nav-icon-circle',
          },
          {
            name: marker('nav.sportbook.sidebarConfig.leagues'),
            url: '/sportbook/sidebar-config/leagues',
            icon: 'nav-icon-circle',
          },
          {
            name: marker('nav.sportbook.sidebarConfig.groups'),
            url: '/sportbook/sidebar-config/groups',
            icon: 'nav-icon-circle',
          },
        ],
      },
      {
        name: marker('nav.sportbook.sports'),
        url: '/sportbook/sports',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['configuration'],
      },
      {
        name: marker('nav.sportbook.exefeed'),
        url: '/sportbook/exefeed',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['configuration'],
      },
      {
        name: marker('nav.sportbook.compGroupsCsv'),
        url: '/sportbook/export-import',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['configuration'],
      },
    ],
  },

  {
    url: '/casino',
    name: marker('nav.casino.title'),
    iconComponent: { name: 'cilDiamond' },
    requiredRolesAny: ['casino.managment'],
    children: [
      {
        name: marker('nav.casino.catalogue'),
        url: '/casino/games',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['casino.managment'],
      },
      {
        name: marker('nav.casino.providers'),
        url: '/casino/providers',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['casino.managment'],
      },
      {
        name: marker('nav.casino.categories'),
        url: '/casino/categories',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['casino.managment'],
      },
      {
        name: marker('nav.casino.groups'),
        url: '/casino/groups',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['casino.managment'],
      },
    ],
  },
  {
    url: '/web-app',
    name: marker('nav.webApp.title'),
    iconComponent: { name: 'cilApplicationsSettings' },
    requiredRolesAny: ['appearance.management'],
    children: [
      {
        name: marker('nav.webApp.customize'),
        url: '/web-app/customize',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['appearance.management'],
      },
      {
        name: marker('nav.webApp.widgets'),
        url: '/web-app/widgets',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['appearance.management'],
      },
      {
        name: marker('nav.webApp.staticPages'),
        url: '/web-app/static-pages',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['appearance.management'],
      },
      {
        name: marker('nav.webApp.brandingAssets'),
        url: '/web-app/branding-assets',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['appearance.management'],
      },
      {
        name: marker('nav.webApp.settings'),
        url: '/web-app/settings',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['appearance.management'],
      },
    ],
  },
  {
    url: '/gamification',
    name: 'Gamification',
    iconComponent: { name: 'cilGamepad' },
    requiredRolesAny: ['admin', 'superadmin', 'configuration'],
    children: [
      {
        name: 'Missions',
        url: '/gamification/missions',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['admin', 'superadmin', 'configuration'],
      },
      {
        name: 'Event Flags',
        url: '/gamification/event-flags',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['admin', 'superadmin', 'configuration'],
      },
      {
        name: 'Event Rewards',
        url: '/gamification/event-rewards',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['admin', 'superadmin', 'configuration'],
      },
      {
        name: 'Collectibles',
        url: '/gamification/collectibles',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['admin', 'superadmin', 'configuration'],
      },
      {
        name: 'Avatars',
        url: '/gamification/avatars',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['admin', 'superadmin', 'configuration'],
      },
      {
        name: 'Treasure Chests',
        url: '/gamification/treasure-chests',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['admin', 'superadmin', 'configuration'],
      },
      {
        name: 'Custom Awards',
        url: '/gamification/custom-awards',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['admin', 'superadmin', 'configuration'],
      },
      {
        name: 'Season Passes',
        url: '/gamification/season-passes',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['admin', 'superadmin', 'configuration'],
      },
      {
        name: 'Season Pass Prizes',
        url: '/gamification/season-pass-prizes',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['admin', 'superadmin', 'configuration'],
      },
      {
        name: 'Tournaments',
        url: '/gamification/tournaments',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['admin', 'superadmin', 'configuration'],
      },
      {
        name: 'Achievements',
        url: '/gamification/achievements',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['admin', 'superadmin', 'configuration'],
      },
      {
        name: 'Leaderboards',
        url: '/gamification/leaderboards',
        icon: 'nav-icon-bullet',
        requiredRolesAny: ['admin', 'superadmin', 'configuration'],
      },
    ],
  },

];
